import { render } from "./Loader.vue?vue&type=template&id=cb4d3494&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=cb4d3494&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4d3494"]])

export default __exports__